export default "__VITE_ASSET__C98eqEID__"